import { AfterViewInit, Component, OnInit, TemplateRef, Type, ViewChild } from '@angular/core';
import { CoreService, ResourceModel, SystemParameterModel, SystemParameterType } from 'src/app/services/api-services';
import { BaseComponent, DataTableRequest, EditComponent, LanguageService, ListItemModel, SearchData, TranslatedToastrService, ValidationHandlerService } from 'lib/Vestra.shared';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { SystemParameterEditComponent } from '../system-parameter-edit/system-parameter-edit.component';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ADTSettings } from 'angular-datatables/src/models/settings';
import { Router } from '@angular/router';
import { HtmlManagementEditComponent } from '../../html-management/html-management-edit/html-management-edit.component';

@Component({
    selector: 'app-system-parameter-list',
    templateUrl: './system-parameter-list.component.html',
    styleUrls: ['./system-parameter-list.component.scss'],
})
export class SystemParameterListComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild('actionsRef') actionsRef: TemplateRef<EditComponent>;

    public type: ListItemModel[] = [];

    constructor(private router: Router, private translatedToastrService: TranslatedToastrService, private translateService: TranslateService, protected override modalService: BsModalService, protected override spinnerService: NgxSpinnerService, private coreService: CoreService, protected override validationHandlerService: ValidationHandlerService, protected override languageService: LanguageService) {
        super(spinnerService, modalService, validationHandlerService, translateService, languageService);
    }
    public override getDtOptions() {
        this.languageUrl = this.languageService.getTranslationUrl();

        const res: ADTSettings = {
            serverSide: true,
            processing: false,
            pageLength: 20,
            lengthChange: false,
            responsive: {
                details: {
                    type: 'column',
                    target: -1,
                },
            },
            searching: false,
            destroy: true,
            language: {
                url: this.languageUrl,
            },
            ajax: (dataTablesParams: any, callback: any) => {
                for (let order of dataTablesParams.order) {
                    order.name = dataTablesParams.columns[order.column]?.data;
                }

                const model: DataTableRequest = {
                    draw: dataTablesParams.draw,
                    start: dataTablesParams.start,
                    length: dataTablesParams.length,
                    order: dataTablesParams.order,
                    columns: this.transformToColumnData(this.dtOptions.columns),
                };

                this.datatableRequest = model;

                this.handleSpinner(firstValueFrom(this.coreService.getSystemParameterListDataSource(model)))
                    .then(res => {
                        callback(this.getTableData(res));
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err);
                        callback(this.getEmptyTableData());
                    });
            },
            columns: [
                {
                    data: 'id',
                    title: 'common.id',
                    searchable: true,
                    orderable: true,
                },
                {
                    data: 'value',
                    title: 'common.value',
                    searchable: false,
                    orderable: true,
                },
                {
                    data: 'description',
                    title: 'common.description',
                    responsivePriority: 1,
                    searchable: false,
                    orderable: true,
                },
                {
                    title: 'common.actions',
                    data: null,
                    searchable: false,
                    orderable: false,
                    defaultContent: '',
                    ngTemplateRef: {
                        ref: this.actionsRef,
                        context: {
                            captureEvents: this.onEditItem.bind(this),
                        },
                    },
                    responsivePriority: 1,
                },
                {
                    data: '',
                    orderable: false,
                    responsivePriority: 1,
                    render: function (data) {
                        return '';
                    },
                },
            ],
            columnDefs: [
                {
                    targets: '_all',
                    visible: true,
                },
                {
                    className: 'details-icon dtr-control',
                    orderable: false,
                    target: -1,
                },
            ],
        };

        return res;
    }
    public ngAfterViewInit() {
        this.dataTableAfterViewInit();
    }

    public ngOnDestroy() {
        this.dataTableOnDestroy();
    }

    public ngOnInit() {
        this.dataTableOnInit();
    }

    public onEditItem(event: any) {
        this.openEditModalWithComponent(event.data);
    }

    public openEditModalWithComponent(item: SystemParameterModel) {
        let modalOptions: ModalOptions = {
            initialState: {
                title: 'system_parameter.title',
                item: item,
            },
        };

        let bsModalRef: BsModalRef = this.modalService.show(SystemParameterEditComponent, modalOptions);
        bsModalRef.onHide.subscribe((reason: string | any) => {
            if (reason === 'save_success') {
                this.translatedToastrService.success('common.save_success', 'common.success');
                this.refreshDataTable();
            }
        });
    }
}
